// 事例検索ページ
// https://kaizen.qiita.com/kazufumi_hamano/listItems/ab7dd09196eb8b5f2c9c

import styled from '@emotion/styled';
import { PlacementType } from '@kaizenplatform/creative-search-entity';
// ================================================ MyFilter ================================================
import {
  Container,
  CreativeIndexForDirectorWeb,
  CreativeList,
  Filter,
  IContainerProps,
  ICreativeListItem,
  ICreativeListProps,
  IFilterProps,
  IImageViewerProps,
  IKeywordFormProps,
  ImageViewer,
  IMobileModalProps,
  IModalProps,
  ISelectControllerProps,
  IVideoViewerProps,
  KeywordForm,
  MobileModal,
  Modal,
  SelectController,
  useCreativeSearch,
  VideoViewer,
} from '@kaizenplatform/creative-search-ui';
import {
  Button,
  Button as MyButton,
  FormControl as _FormControl,
  FormControlLabel,
  Input,
  MenuItem,
  Switch,
  Typography as MyTypography,
  Typography,
} from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MyAddCircleIcon from '@material-ui/icons/AddCircle';
import CheckIcon from '@material-ui/icons/Check';
import FileCopy from '@material-ui/icons/FileCopyOutlined';
import MyFavoriteIcon from '@material-ui/icons/Star';
import StarIcon from '@material-ui/icons/Star';
import MyFavoriteBorderIcon from '@material-ui/icons/StarBorder';
import dayjs from 'dayjs';
import { ChangeEvent, createElement, CSSProperties, FC, Fragment, useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactSelect from 'react-select';
import { Waypoint as MyWaypoint } from 'react-waypoint';

import { SEIHOS, TATENAGAS, YOKONAGAS } from '../../../constant/aspectRatio';
import { DURATION_ENUM, DURATION_ENUM_US } from '../../../constant/duration';
import Config from '../../../core/Config';
import { OrganizationDetailFragment } from '../../../generated/graphql';
import MySpinner from '../../component/compound/Spinner';
import AmazonIcon from '../../component/primitive/AmazonIcon';
import AppleIcon from '../../component/primitive/AppleIcon';
import FacebookIconWithOriginalColor from '../../component/primitive/FacebookIconWithOriginalColor';
import GoogleIcon from '../../component/primitive/GoogleIcon';
import InstagramIcon from '../../component/primitive/InstagramIcon';
import LineIcon from '../../component/primitive/LineIcon';
import SnapchatIcon from '../../component/primitive/SnapchatIcon';
import TwitterIcon from '../../component/primitive/TwitterIcon';
import YahooIcon from '../../component/primitive/YahooIcon';
import YouTubeIcon from '../../component/primitive/YouTubeIcon';
import { context as DependencyContext } from '../../context/dependency';
import { context as CoreStateContext } from '../../context/state';
import mq from '../../styleUtility/mediaquery';

export const PLACEMENT_IMAGE_ENUM: { [x in PlacementType]: JSX.Element } = {
  facebook: <FacebookIconWithOriginalColor size={24} />,
  twitter: <TwitterIcon size={24} />,
  instagram: <InstagramIcon size={24} />,
  snapchat: <SnapchatIcon size={24} />,
  youtube: <YouTubeIcon size={24} />,
  google: <GoogleIcon size={24} />,
  line: <LineIcon size={24} />,
  yahoo: <YahooIcon size={24} />,
  owned_media: <div />,
  other: <div />,
  apple: <AppleIcon size={24} />,
  amazon: <AmazonIcon size={24} />,
};

const KAIZEN_PLATFORM_EMAIL_DOMAIN = 'kaizenplatform.com';

type Props = {
  currentOrganization?: OrganizationDetailFragment;
};

const AdSearchPage: FC<Props> = ({ currentOrganization }) => {
  const config: Config = (window as any).__hugotconfig__;
  const state = useContext(CoreStateContext);
  const currentOrganizationId = currentOrganization ? currentOrganization.id : undefined;

  const {
    isLoadingMoreVideos,
    data,
    searchWithCondition,
    closeMobileModal,
    updateFavStatus,
    fetchNextCreatives,
    onClickTagAdd,
    onClickTagDelete,
    selectedCardForModal,
    isMobile,
    setSpSearchModal,
    searchKeyWord,
    handleChangeQuery,
    isOpenSearchMobileModal,
    apiErrors,
    resetApiErrors,
    selectedCardForMobileModal,
    selectdCards,
  } = useCreativeSearch({
    baseUrl: new URL(config.CREATIVE_API_BASE_URL),
    staticQuery: { scope: [1, 2], contentTypes: ['video/*'], service: ['ad'] },
    breakpointForMobile: 768,
    organizationId: currentOrganizationId,
    targetStreamingUrl: 'logoWatermarkHlsUrl',
  });

  const lastUpdatedAt = data?.creatives[0].fileUpdatedAt;

  // [optional] Filterまたは Filter の contentRender で department を使用したい
  const department = state.availableOrganizations.items.map((org) => {
    // @kaizenplatform/creative-search-uiがentityの引数を期待してるからコンパイル通すための無理やり変換
    const businessRegion = { ...org.businessRegion, toJSON: () => org.businessRegion };
    const json = {
      ...org,
      pointBalance: org.pointBalance ?? null,
      businessRegion: businessRegion,
    };
    return {
      ...json,
      toJSON: () => json,
    };
  });

  const userEmail = state.authentication.signedInUser?.email ?? '';

  const domain = userEmail.split('@')[1];
  const hasCopyUrlRight = domain === KAIZEN_PLATFORM_EMAIL_DOMAIN;

  const [isFileCopyHovered, setIsFileCopyHovered] = useState(false);
  const [isFileCopied, setIsFileCopied] = useState(false);

  // [optional] クリエティブリストのカードのフッター拡張領域に要素を追加したい
  const myCardFooterElement = (creativeListItem: ICreativeListItem) => {
    const { placement, aspectRatio, favorite } = creativeListItem;

    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <div style={{ display: 'flex' }}>
          {placement ? PLACEMENT_IMAGE_ENUM[placement] : <div />}
          <p style={{ margin: 'auto', paddingLeft: '5px' }}>{aspectRatio}</p>
        </div>

        <FavWrapper>
          {favorite === 1 ? (
            <MyFav
              onClick={(e) => {
                e.stopPropagation();
                updateFavStatus(creativeListItem);
              }}
            />
          ) : (
            <MyUnFav
              onClick={(e) => {
                e.stopPropagation();
                updateFavStatus(creativeListItem);
              }}
            />
          )}

          <div className="tool-tip-description">
            <FormattedMessage id={'creative_search_ui.filter.favorite.tooltip'} />
          </div>
        </FavWrapper>
      </div>
    );
  };

  const FavWrapper = styled('div')({
    position: 'relative',
    cursor: 'pointer',
    display: 'inline-block',
    '&:hover .tool-tip-description': {
      display: 'inline-block',
      top: '-30px',
      left: '-85px',
    },
    '.tool-tip-description': {
      width: '110px',
      display: 'none',
      position: 'absolute',
      padding: '5px',
      fontSize: '8px',
      lineHeight: '1.2em',
      color: '#fff',
      borderRadius: '5px',
      background: 'gray',
      // whiteSpace: 'nowrap',
    },
  });

  // [optional] メディアモーダルのフッター拡張領域に要素を追加したい
  const myMediaModalFooterElement = (creativeListItem: ICreativeListItem) => {
    const { placement, aspectRatio } = creativeListItem;
    const isCopyable = creativeListItem.previewWartermarkMp4Url && hasCopyUrlRight;

    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <div
          style={
            isCopyable
              ? { display: 'flex', justifyContent: 'flex-start', width: '80%' }
              : { display: 'flex', justifyContent: 'space-between', width: '100%' }
          }
        >
          {placement ? PLACEMENT_IMAGE_ENUM[placement] : null}
          <p style={isCopyable && !!placement ? { margin: 'auto 5px' } : { margin: 'auto 0' }}>{aspectRatio}</p>
        </div>

        {isCopyable && (
          <div
            style={{ cursor: 'pointer' }}
            onMouseEnter={() => {
              setIsFileCopyHovered(true);
            }}
            onMouseLeave={() => {
              setIsFileCopyHovered(false);
            }}
            onClick={() => {
              setIsFileCopied(true);
              navigator.clipboard.writeText(creativeListItem.previewWartermarkMp4Url!);
              setTimeout(() => {
                setIsFileCopied(false);
              }, 1000);
            }}
          >
            {isFileCopied ? (
              <CheckIcon style={{ color: '#04a46f' }} />
            ) : (
              <FileCopy style={isFileCopyHovered ? { color: '#04a46f' } : { color: 'gray' }} />
            )}
          </div>
        )}
      </div>
    );
  };

  // [optional] モーダルのフッター拡張領域に要素を追加したい
  const { adSearchUsecase } = useContext(DependencyContext);
  const createContentButton = (
    <MyButton
      variant="text"
      onClick={() => {
        adSearchUsecase.moveToCreateNewProject();
      }}
    >
      <MyAddCircleIcon style={{ marginRight: 12, color: '#4C566C' }} />

      <MyTypography>
        <FormattedMessage id={'creative_search_ui.media_modal.create_contents'} />
      </MyTypography>
    </MyButton>
  );

  // [optional] creative-search-ui 内で発生した、api通信に関するエラーを処理したい
  useEffect(() => {
    if (apiErrors.fetchCreativeList) {
      const { isApiError, message, responseStatus, responseBody } = apiErrors.fetchCreativeList;
      console.error({ isApiError, message, responseStatus, responseBody });
      resetApiErrors.fetchCreativeList();
    }

    if (apiErrors.fetchSelectedCreatives) {
      const { isApiError, message, responseStatus, responseBody } = apiErrors.fetchSelectedCreatives;
      console.error({ isApiError, message, responseStatus, responseBody });
      resetApiErrors.fetchSelectedCreatives();
    }

    if (apiErrors.postOrganizationTag) {
      const { isApiError, message, responseStatus, responseBody } = apiErrors.postOrganizationTag;
      console.error({ isApiError, message, responseStatus, responseBody });
      resetApiErrors.postOrganizationTag();
    }

    if (apiErrors.deleteOrganizationTag) {
      const { isApiError, message, responseStatus, responseBody } = apiErrors.deleteOrganizationTag;
      console.error({ isApiError, message, responseStatus, responseBody });

      resetApiErrors.deleteOrganizationTag();
    }

    if (apiErrors.postFavorite) {
      const { isApiError, message, responseStatus, responseBody } = apiErrors.postFavorite;
      console.error({ isApiError, message, responseStatus, responseBody });
      resetApiErrors.postFavorite();
    }

    if (apiErrors.deleteFavorite) {
      const { isApiError, message, responseStatus, responseBody } = apiErrors.deleteFavorite;
      console.error({ isApiError, message, responseStatus, responseBody });
      resetApiErrors.deleteFavorite();
    }
  }, [
    apiErrors.fetchCreativeList,
    apiErrors.fetchSelectedCreatives,
    apiErrors.postOrganizationTag,
    apiErrors.deleteOrganizationTag,
    apiErrors.postFavorite,
    apiErrors.deleteFavorite,
    resetApiErrors,
  ]);

  const kaizenPlayerCss: CSSProperties = {
    width: '100%',
    height: '100%',
    minWidth: 'unset',
    borderRadius: '5px 5px 0 0',
  };

  return (
    <Container loadingSpinner={<MySpinner />} overrideCss={myOverrideCssContainer}>
      <KeywordForm searchWithCondition={searchWithCondition} overrideCss={myOverrideCssKeywordForm} />

      <Filter
        searchWithCondition={searchWithCondition}
        facetList={undefined} // contentRender を使用する場合は facetList の指定が不要
        department={department} // contentRender で department を使用する場合には指定が必須
        contentRender={(args) =>
          !isMobile ? (
            <MyFilter facets={data?.facets} {...args} />
          ) : (
            <MySpFilter
              facets={data?.facets}
              isMobile={isMobile}
              isOpen={isOpenSearchMobileModal}
              searchWithCondition={searchWithCondition}
              setSpSearchModal={setSpSearchModal}
              searchKeyWord={searchKeyWord}
              handleChangeQuery={handleChangeQuery}
              {...args}
            />
          )
        }
        overrideCss={myOverrideCssFilter}
      />

      {lastUpdatedAt && (
        <LastUpdatedAtWrapper>
          <FormattedMessage
            id={'creative_search_ui.filter.last_updated_at'}
            values={{
              date: dayjs(lastUpdatedAt).format('YYYY/MM/DD'),
            }}
          />
        </LastUpdatedAtWrapper>
      )}

      <SelectController creatives={selectdCards} overrideCss={myOverrideCssSelectController} />

      <CreativeList
        cols={4}
        isSelectable
        creatives={data?.creatives || []}
        config={{ PROFILE_WEB_URL: config.PROFILE_WEB_URL }}
        displayProperties={department.length > 0 ? ['ghInfo', 'tag', 'cardFooter'] : ['ghInfo', 'cardFooter']}
        cardFooterElement={myCardFooterElement}
        overrideCss={myOverrideCssCreativeList}
        kaizenPlayerCss={kaizenPlayerCss}
      />

      {/* 無限スクロール用のローダー */}
      <MyWaypoint onEnter={() => fetchNextCreatives()} />
      {isLoadingMoreVideos && <MySpinner />}
      <FormattedMessage id={'creative_search_ui.media_modal.title'}>
        {(message: string) => (
          <Modal
            creatives={selectedCardForModal}
            title={message}
            footer={createContentButton}
            onClickTagAdd={onClickTagAdd}
            onClickTagDelete={onClickTagDelete}
            displayProperties={['contentFooter', 'modalFooter']}
            cardFooterElement={myMediaModalFooterElement}
            contentRender={(content) => {
              if (content.data.contentType.startsWith('video')) {
                return <VideoViewer content={content} />;
              }
              if (content.data.contentType.startsWith('image')) {
                return <ImageViewer content={content} />;
              }
              if (content.data.contentType === 'pdf') {
                return <div>pdf modal content</div>;
              }
              return <div>error</div>;
            }}
            onClose={() => {
              if (currentOrganizationId) {
                closeMobileModal(`/search?org=${currentOrganizationId}`);
              } else {
                closeMobileModal('/search');
              }
            }}
            overrideCss={myOverrideCssModal}
            organizationId={currentOrganizationId}
          />
        )}
      </FormattedMessage>

      {selectedCardForMobileModal && (
        <MobileModal
          creative={selectedCardForMobileModal}
          displayProperties={['ghInfo', 'contentFooter', 'footerChild']}
          config={{ PROFILE_WEB_URL: config.PROFILE_WEB_URL }}
          onClose={() => {
            if (currentOrganizationId) {
              closeMobileModal(`/search?org=${currentOrganizationId}`);
            } else {
              closeMobileModal('/search');
            }
          }}
          cardFooterElement={myCardFooterElement}
          footerChild={createContentButton}
          overrideCss={myOverrideCssMobileModal}
        />
      )}
    </Container>
  );
};

const MyFav = styled(MyFavoriteIcon)`
  padding: 0px;
  color: #f8c324;
  cursor: pointer;
`;

const MyUnFav = styled(MyFavoriteBorderIcon)`
  padding: 0px;
  color: #f8c324;
  cursor: pointer;
`;

// [optional] creative-search-ui から import した UIコンポーネントの css を上書きしたい
const myOverrideCssContainer: IContainerProps['overrideCss'] = undefined;

const myOverrideCssKeywordForm: IKeywordFormProps['overrideCss'] = () => ({
  '&.csui-kf-wrapper': {
    margin: '10px 4px',
  },
  '.csui-kf-input-wrapper-pc': { width: '100%' },
  '.csui-kf-wrapper-pc': { margin: '0 15px' },
});

const myOverrideCssFilter: IFilterProps['overrideCss'] = () => ({
  '.csui-fil-pc-wr-wrapper': { display: 'none' },
});

const myOverrideCssSelectController: ISelectControllerProps['overrideCss'] = () => ({
  '.csui-sc-play-button': { marginLeft: '15px' },
});

const myOverrideCssCreativeList: ICreativeListProps['overrideCss'] = {
  wrapper: undefined,
  card: ({ isMobile, cols }) => ({
    '&.csui-cl-card-wrapper': {
      width: isMobile ? 'calc(50% - 8px)' : `${100 / (cols || 4) - 3}%`,
      borderRadius: '5px',
    },
    '.csui-cl-card-pc-wrapper': {
      borderRadius: '5px',
    },
    '.csui-cl-card-pc-creative-wrapper': { backgroundColor: 'gray', borderRadius: '5px 5px 0 0' },
    '.csui-cl-card-pc-video-screen': { backgroundColor: 'gray', borderRadius: '5px 5px 0 0' },
    '.csui-cl-card-pc-video-title': { height: '26.67px' },
    '.csui-cl-card-pc-info-wrapper': { padding: '16px 8px 12px 8px' },
    '.csui-cl-card-pc-img-screen-wrapper': { objectFit: 'cover', borderRadius: '5px 5px 0 0' },
    '.csui-cl-card-pc-video-thumbnail': { objectFit: 'cover', backgroundColor: 'gray' },
    '.csui-cl-card-mobile-img': { objectFit: 'cover' },
    '.csui-cl-card-pc-footer-wrapper': { paddingTop: '5px' },
    '.csui-cl-card-pc-tag-span': { borderRadius: '3px' },
  }),
};

const myOverrideCssImageViewer: IImageViewerProps['overrideCss'] = undefined;

const myOverrideCssVideoViewer: IVideoViewerProps['overrideCss'] = undefined;

const myOverrideCssModal: IModalProps['overrideCss'] = {
  modal: () => ({
    '&.csui-mdl-wrapper': { padding: '0 30px 0 120px' },
    '.csui-mdl-overlay': { width: '70%', maxWidth: '1080px' },
    '.csui-mdl-media-player-wrapper:not(:last-child)': { marginRight: 10 },
  }),

  imageViewer: myOverrideCssImageViewer,
  videoViewer: myOverrideCssVideoViewer,
};

const myOverrideCssMobileModal: IMobileModalProps['overrideCss'] = () => ({
  '.csui-mobile-mdl-footer-wrapper ': { justifyContent: 'center' },
});

export default AdSearchPage;

// プレイスメントenum
const PLACEMENT_ENUM: { [x in PlacementType]: string } = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  snapchat: 'Snapchat',
  youtube: 'YouTube',
  twitter: 'Twitter',
  line: 'LINE',
  yahoo: 'Yahoo',
  google: 'Google',
  owned_media: '自社メディア',
  other: 'その他',
  apple: 'Apple',
  amazon: 'Amazon',
} as const;
// プレイスメントenum
const PLACEMENT_ENUM_US: { [x in PlacementType]: string } = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  snapchat: 'Snapchat',
  youtube: 'YouTube',
  twitter: 'Twitter',
  line: 'LINE',
  yahoo: 'Yahoo',
  google: 'Google',
  owned_media: 'Own Media',
  other: 'Others',
  apple: 'Apple',
  amazon: 'Amazon',
} as const;

type FilterContentRenderArgs = Parameters<Exclude<IFilterProps['contentRender'], undefined>>[0];

interface IMyFilterProps extends FilterContentRenderArgs {
  facets?: CreativeIndexForDirectorWeb['facets'];
}

const MyFilter: FC<IMyFilterProps> = ({
  facets,
  getFilterClickHandler,
  handleSelectedTags,
  filterState: { selectedPlacement, selectedDuration, selectedAspect, selectedIndustry, isFavFilter },
  defaultSelected,
  department,
}) => {
  const state = useContext(CoreStateContext);
  const PLACEMENT = state.language == 'ja-JP' ? PLACEMENT_ENUM : PLACEMENT_ENUM_US;
  const DURATION = state.language == 'ja-JP' ? DURATION_ENUM : DURATION_ENUM_US;

  return (
    <PCOnly>
      <SearchRowBase>
        <SelectBoxRow data-intercom-target={'creative-search-select-filters'}>
          {facets && Array.isArray(facets.placement?.buckets) && facets.placement.buckets.length > 0 && (
            <FormControl>
              <InputLabel id="label-placement">
                <FormattedMessage id={'creative_search_ui.filter.placement'} />
              </InputLabel>

              <Select
                value={selectedPlacement || defaultSelected.placement}
                onChange={getFilterClickHandler('placement')}
              >
                <MenuItem value={defaultSelected.placement} key="all">
                  <FormattedMessage id={'creative_search_ui.filter.all'} />
                </MenuItem>

                {facets.placement.buckets.map(
                  (bucket) =>
                    // @ts-ignore bucket.valueがstringで潰れているため。PLACEMENT_ENUM[bucket.value がなくても(stringじゃなくても)undefinedになりガードするので大丈夫
                    !!PLACEMENT[bucket.value] && (
                      //
                      <MenuItem value={bucket.value} key={bucket.value}>
                        {
                          // @ts-ignore bucket.valueがstringで潰れているため。PLACEMENT_ENUM[bucket.value がなくても(stringじゃなくても)undefinedになりガードされるので大丈夫
                          PLACEMENT[bucket.value]
                        }
                      </MenuItem>
                    ),
                )}
              </Select>
            </FormControl>
          )}

          <FormControl>
            <InputLabel id="label-duration">
              <FormattedMessage id={'creative_search_ui.filter.length'} />
            </InputLabel>

            <Select value={selectedDuration || defaultSelected.duration} onChange={getFilterClickHandler('duration')}>
              <MenuItem value={defaultSelected.duration} key="all">
                <FormattedMessage id={'creative_search_ui.filter.all'} />
              </MenuItem>

              {Object.entries(DURATION).map((duration) => (
                <MenuItem value={duration[1]} key={duration[1]}>
                  {duration[0]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {facets && Array.isArray(facets.aspectRatio?.buckets) && facets.aspectRatio.buckets.length > 0 && (
            <FormControl>
              <InputLabel id="label-aspect">
                <FormattedMessage id={'creative_search_ui.filter.aspect_ratio'} />
              </InputLabel>

              <Select
                value={selectedAspect || defaultSelected.aspectRatio}
                onChange={getFilterClickHandler('aspectRatio')}
              >
                <MenuItem value={defaultSelected.aspectRatio} key="all">
                  <FormattedMessage id={'creative_search_ui.filter.all'} />
                </MenuItem>

                {facets.aspectRatio.buckets
                  .filter((bucket) => YOKONAGAS.includes(bucket.value))
                  .map((bucket) => (
                    <MenuItem value={bucket.value} key={bucket.value}>
                      <AspectIconHorizontal src="/assets/sp_rotate.png" />
                      <FormattedMessage id={'creative_search_ui.filter.aspect_ratio.landscape'}></FormattedMessage>
                      {bucket.value}
                    </MenuItem>
                  ))}

                {facets.aspectRatio.buckets
                  .filter((bucket) => TATENAGAS.includes(bucket.value))
                  .map((bucket) => (
                    <MenuItem value={bucket.value} key={bucket.value}>
                      <AspectIconVertical src="/assets/sp_normal.png" />
                      <FormattedMessage id={'creative_search_ui.filter.aspect_ratio.portrait'} />
                      {bucket.value}
                    </MenuItem>
                  ))}

                {facets.aspectRatio.buckets
                  .filter((bucket) => SEIHOS.includes(bucket.value))
                  .map((bucket) => (
                    <MenuItem value={bucket.value} key={bucket.value}>
                      <AspectIconSquare src="/assets/sp_square.png" />
                      <FormattedMessage id={'creative_search_ui.filter.aspect_ratio.square'} />
                      {bucket.value}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}

          {facets && Array.isArray(facets.industry?.buckets) && facets.industry.buckets.length > 0 && (
            <FormControl>
              <InputLabel id="label-industry">
                <FormattedMessage id={'creative_search_ui.filter.industry'} />
              </InputLabel>

              <Select value={selectedIndustry || defaultSelected.industry} onChange={getFilterClickHandler('industry')}>
                <MenuItem value={defaultSelected.industry} key="all">
                  <FormattedMessage id={'creative_search_ui.filter.all'} />
                </MenuItem>

                {facets.industry.buckets.map((bucket) => (
                  <MenuItem value={bucket.value} key={bucket.value}>
                    {bucket.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {department.length >= 1 &&
            facets &&
            Array.isArray(facets.organizationTag?.buckets) &&
            facets.organizationTag.buckets.length > 0 && (
              <FormattedMessage id={'creative_search_ui.filter.tag'}>
                {(message: string) => (
                  <FormControl style={{ minWidth: 200, maxWidth: 400 }}>
                    <ReactSelect
                      menuPortalTarget={document.body}
                      styles={{
                        placeholder: (base) => ({
                          ...base,
                          fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                          fontWeight: 'lighter',
                          fontSize: '14px',
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      placeholder={message}
                      onChange={(e) => {
                        const dispatchedVal = Array.isArray(e)
                          ? (e as { value: string; label: JSX.Element }[]).reduce<string[]>((acc, cur) => {
                              if (!('value' in cur)) return acc;

                              return [...acc, cur.value];
                            }, [])
                          : [];
                        handleSelectedTags(dispatchedVal.length > 0 ? { type: 'or', values: dispatchedVal } : []);
                      }}
                      closeMenuOnSelect={false}
                      isMulti
                      options={facets.organizationTag.buckets.map((b) => {
                        return {
                          value: b.value,
                          label: <Typography>{b.value}</Typography>,
                        };
                      })}
                      name="colors"
                      classNamePrefix="select"
                    />
                  </FormControl>
                )}
              </FormattedMessage>
            )}

          <FormattedMessage id={'creative_search_ui.filter.favorite'}>
            {(message: string) => (
              <FormControlLabel
                control={
                  <>
                    <Switch
                      color="primary"
                      checked={isFavFilter}
                      onChange={getFilterClickHandler('favorite')}
                      name="favorite"
                    />
                    <StarIcon fontSize="small" />
                  </>
                }
                label={message}
                labelPlacement="end"
              />
            )}
          </FormattedMessage>
        </SelectBoxRow>
      </SearchRowBase>
    </PCOnly>
  );
};

// MyFilter styles
const FormControl = styled(_FormControl)({
  minWidth: '120px',
  maxWidth: '180px',
  [mq('sp')]: {
    minWidth: '45%',
  },
});

const SearchRowBase = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: '6px',
  alignItems: 'flex-end',
  flexWrap: 'wrap',
});

const PCOnly = styled('div')({
  [mq('sp')]: {
    display: 'none',
  },
});

const SelectBoxRow = styled(SearchRowBase)`
  width: 100%;
  margin-left: 15px;
  justify-content: start;
  > * {
    margin-right: 12px;
  }
`;

const AspectIconBase = styled('img')``;

const AspectIconVertical = styled(AspectIconBase)`
  width: 18px;
  height: 27px;
  margin-right: 17px;
`;

const AspectIconHorizontal = styled(AspectIconBase)`
  width: 27px;
  height: 18px;
  margin-right: 7px;
`;

const AspectIconSquare = styled(AspectIconBase)`
  width: 27px;
  height: 27px;
  margin-right: 7px;
`;

//====================================================== MySpFilter ==============================================================================

// SPにおける検索用コンポーネント

interface IMySpFilterProps extends FilterContentRenderArgs {
  searchWithCondition: () => void;
  setSpSearchModal: (status: boolean) => void;
  handleChangeQuery: (e: ChangeEvent<{ value: unknown }>) => void;
  searchKeyWord: string | undefined;
  isOpen: boolean;
  isMobile: boolean;
  facets?: CreativeIndexForDirectorWeb['facets'];
}

const MySpFilter: FC<IMySpFilterProps> = ({
  handleChangeQuery,
  facets,
  getFilterClickHandler,
  isOpen,
  searchKeyWord,
  isMobile,
  setSpSearchModal,
  searchWithCondition,
  handleSelectedTags,
  filterState: { selectedPlacement, selectedDuration, selectedAspect, selectedIndustry, isFavFilter },
  defaultSelected,
  department,
}) => {
  const state = useContext(CoreStateContext);
  const PLACEMENT = state.language == 'ja-JP' ? PLACEMENT_ENUM : PLACEMENT_ENUM_US;
  const DURATION = state.language == 'ja-JP' ? DURATION_ENUM : DURATION_ENUM_US;

  return (
    <Wrapper isOpen={isOpen}>
      <div style={{ display: 'flex', marginBottom: 16, marginTop: 24 }}>
        <FormattedMessage id={'creative_search_ui.key_word_form.placeholder'}>
          {(message: string) => (
            <Input
              style={{ flexGrow: 1 }}
              placeholder={message}
              autoFocus={!isMobile}
              defaultValue={searchKeyWord}
              onBlur={(e) => {
                handleChangeQuery(e);
              }}
            />
          )}
        </FormattedMessage>
      </div>
      {facets && Array.isArray(facets.placement?.buckets) && facets.placement.buckets.length > 0 && (
        <FormControl style={{ width: '100%', maxWidth: '100%', marginBottom: 12 }}>
          <FormattedMessage id={'creative_search_ui.filter.placement'}>
            {(message: string) => <label>{message}</label>}
          </FormattedMessage>
          <Select
            value={selectedPlacement || defaultSelected.placement}
            onChange={getFilterClickHandler('placement')}
            displayEmpty={false}
            native
          >
            <FormattedMessage id={'creative_search_ui.filter.all'}>
              {(message: string) => (
                <option value={defaultSelected.placement} key="all">
                  {message}
                </option>
              )}
            </FormattedMessage>
            {facets.placement.buckets.map(
              (bucket) =>
                // @ts-ignore bucket.valueがstringで潰れているため。PLACEMENT_ENUM[bucket.value がなくても(stringじゃなくても)undefinedになりガードするので大丈夫
                !!PLACEMENT[bucket.value] && (
                  <option value={bucket.value} key={bucket.value}>
                    {
                      // @ts-ignore bucket.valueがstringで潰れているため。PLACEMENT_ENUM[bucket.value がなくても(stringじゃなくても)undefinedになりガードされるので大丈夫
                      PLACEMENT[bucket.value]
                    }
                  </option>
                ),
            )}
          </Select>
        </FormControl>
      )}

      <FormControl style={{ width: '100%', maxWidth: '100%', marginBottom: 12 }}>
        <FormattedMessage id={'creative_search_ui.filter.length'}>
          {(message: string) => <label id="label-duration">{message}</label>}
        </FormattedMessage>
        <Select
          value={selectedDuration || defaultSelected.duration}
          onChange={getFilterClickHandler('duration')}
          displayEmpty={true}
          native
        >
          <FormattedMessage id={'creative_search_ui.filter.all'}>
            {(message: string) => (
              <option value={defaultSelected.duration} key="all">
                {message}
              </option>
            )}
          </FormattedMessage>
          {Object.entries(DURATION).map((duration) => (
            <option value={duration[1]} key={duration[1]}>
              {duration[0]}
            </option>
          ))}
        </Select>
      </FormControl>

      {facets && Array.isArray(facets.aspectRatio?.buckets) && facets.aspectRatio.buckets.length > 0 && (
        <FormControl style={{ width: '100%', maxWidth: '100%', marginBottom: 12 }}>
          <FormattedMessage id={'creative_search_ui.filter.aspect_ratio'}>
            {(message: string) => <label>{message}</label>}
          </FormattedMessage>
          <Select
            value={selectedAspect || defaultSelected.aspectRatio}
            onChange={getFilterClickHandler('aspectRatio')}
            native
          >
            <FormattedMessage id={'creative_search_ui.filter.all'}>
              {(message: string) => (
                <option value={defaultSelected.aspectRatio} key="all">
                  {message}
                </option>
              )}
            </FormattedMessage>
            <FormattedMessage id={'creative_search_ui.filter.aspect_ratio.landscape'}>
              {(message: string) =>
                facets.aspectRatio.buckets
                  // @ts-ignore TODO: entity側にバリデーションと例外のthrowを実装し独自型を返すようにする(事例検索v2で対応)
                  .filter((bucket) => YOKONAGAS.includes(bucket.value))
                  .map((bucket) => (
                    <option value={bucket.value} key={bucket.value}>
                      {message}({bucket.value})
                    </option>
                  ))
              }
            </FormattedMessage>
            <FormattedMessage id={'creative_search_ui.filter.aspect_ratio.portrait'}>
              {(message: string) =>
                facets.aspectRatio.buckets
                  // @ts-ignore TODO: entity側にバリデーションと例外のthrowを実装し独自型を返すようにする(事例検索v2で対応)
                  .filter((bucket) => TATENAGAS.includes(bucket.value))
                  .map((bucket) => (
                    <option value={bucket.value} key={bucket.value}>
                      {message}({bucket.value})
                    </option>
                  ))
              }
            </FormattedMessage>
            <FormattedMessage id={'creative_search_ui.filter.aspect_ratio.square'}>
              {(message: string) =>
                facets.aspectRatio.buckets
                  // @ts-ignore TODO: entity側にバリデーションと例外のthrowを実装し独自型を返すようにする(事例検索v2で対応)
                  .filter((bucket) => SEIHOS.includes(bucket.value))
                  .map((bucket) => (
                    <option value={bucket.value} key={bucket.value}>
                      {message}({bucket.value})
                    </option>
                  ))
              }
            </FormattedMessage>
          </Select>
        </FormControl>
      )}

      {facets && Array.isArray(facets.industry?.buckets) && facets.industry.buckets.length > 0 && (
        <FormControl style={{ width: '100%', maxWidth: '100%', marginBottom: 12 }}>
          <FormattedMessage id={'creative_search_ui.filter.industry'}>
            {(message: string) => <label>{message}</label>}
          </FormattedMessage>
          <Select
            value={selectedIndustry || defaultSelected.industry}
            onChange={getFilterClickHandler('industry')}
            native
          >
            <FormattedMessage id={'creative_search_ui.filter.all'}>
              {(message: string) => (
                <option value={defaultSelected.industry} key="all">
                  {message}
                </option>
              )}
            </FormattedMessage>
            {facets.industry.buckets.map((bucket) => (
              <option value={bucket.value} key={bucket.value}>
                {bucket.value}
              </option>
            ))}
          </Select>
        </FormControl>
      )}

      {department.length >= 1 &&
        facets &&
        Array.isArray(facets.organizationTag?.buckets) &&
        facets.organizationTag.buckets.length > 0 && (
          <FormattedMessage id={'creative_search_ui.filter.tag'}>
            {(message: string) => (
              <FormControl style={{ minWidth: 200, maxWidth: 400 }}>
                <ReactSelect
                  menuPortalTarget={document.body}
                  styles={{
                    placeholder: (base) => ({
                      ...base,
                      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                      fontWeight: 'lighter',
                      fontSize: '14px',
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  placeholder={message}
                  onChange={(e) => {
                    const dispatchedVal = Array.isArray(e)
                      ? (e as { value: string; label: JSX.Element }[]).reduce<string[]>((acc, cur) => {
                          if (!('value' in cur)) return acc;

                          return [...acc, cur.value];
                        }, [])
                      : [];
                    handleSelectedTags(dispatchedVal.length > 0 ? { type: 'or', values: dispatchedVal } : []);
                  }}
                  closeMenuOnSelect={false}
                  isMulti
                  options={facets.organizationTag.buckets.map((b) => {
                    return {
                      value: b.value,
                      label: <Typography>{b.value}</Typography>,
                    };
                  })}
                  name="colors"
                  classNamePrefix="select"
                />
              </FormControl>
            )}
          </FormattedMessage>
        )}

      <FormattedMessage id={'creative_search_ui.filter.favorite'}>
        {(message: string) => (
          <FormControl style={{ width: '100%', maxWidth: '100%', marginBottom: 12 }}>
            <FormControlLabel
              control={<Switch checked={isFavFilter} onChange={getFilterClickHandler('favorite')} name="favorite" />}
              label={message}
            />
          </FormControl>
        )}
      </FormattedMessage>

      <FormattedMessage id={'creative_search_ui.search'}>
        {(message: string) => (
          <Button
            style={{ width: '100%', marginTop: 16 }}
            type="button"
            onClick={() => {
              searchWithCondition();
              setSpSearchModal(false);
            }}
          >
            {message}
          </Button>
        )}
      </FormattedMessage>

      <FormattedMessage id={'creative_search_ui.close'}>
        {(message: string) => (
          <Button
            style={{ width: '100%', marginTop: 16, marginBottom: 100 }}
            type="button"
            onClick={() => setSpSearchModal(false)}
          >
            {message}
          </Button>
        )}
      </FormattedMessage>
    </Wrapper>
  );
};

const Wrapper = styled('div')<{ isOpen: boolean }>`
  position: fixed;
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  background-color: white;
  top: 0;
  left: 0;
  z-index: 3;
  padding: 12px;
  padding-top: 62px;
  transition: all 0.3s ease-in-out 0s;
  transform: ${(props) => (props.isOpen ? 'translateY(0%)' : 'translateY(-100%)')};
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const LastUpdatedAtWrapper = styled('div')`
  margin: 16px;
`;
